import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { FullTagResponse } from 'app/modules/tags/responses';
import { TAGS_QUERY_KEYS } from 'app/modules/tags/queries/keys';

export const useGetTags = <TSelect = FullTagResponse[],>(options?: {
  enabled?: boolean;
  select?: (data: FullTagResponse[]) => TSelect;
}) => {
  return useQuery({
    queryFn: () => get<FullTagResponse[]>('/v1/tags/list'),
    queryKey: TAGS_QUERY_KEYS.getTags(),
    ...options,
  });
};
